<template>
  <div>
    <div class="part3">
      <div class="text-left">
        <el-form v-model="form">
          <el-form-item>
            <div class="space-x-8 flex flex-nowrap">
              <el-button plain class="w-48" @click="addCart">
                <span class="iconfont icon-cart"></span>
                {{ $t("加入购物车") }}
              </el-button>
              <el-button type="primary" class="w-48" @click="buy">{{
                $t("购买")
              }}</el-button>
              <div class="
                                                            cursor-pointer
                                                            flex flex-col
                                                            leading-snug
                                                            flex-wrap
                                                            items-center
                                                          " @click="addFavorite(is_favorite)"
                :class="{ favorite: is_favorite }">
                <span class="iconfont icon-shoucang text-xl"></span>
                <span class="text-xs">{{ $t("收藏") }}</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  watch,
  onMounted,
  computed,
} from "@vue/composition-api";
import Radio from "@/components/base/radio.vue";

import { getAreas } from "/src/API/flight/getAreas.js";
import bus from "@/API/util/bus.js";
import { find, path } from "ramda";
export default {
  components: { Radio },
  props: {
    curWh: String,
  },
  setup(props, ctx) {
    const areas = reactive({})
    const flightId = ref();
    const form = reactive({
      count: 1,
      flightId: flightId,
    });
    const thatVuex = ctx.root.$store.state.receiving;
    const query = reactive({
      area: thatVuex.localId,
      date: thatVuex.localTime,
    });
    const changeId = (id) => {
      ctx.root.$store.commit("SET_localId", id);
    };
    const changeDate = (date) => {
      ctx.root.$store.commit("SET_localTime", date);
    };
    bus.on("changeCount", (e) => {
      form.count = e;
    });

    const items = ref();
    const itemsLength = computed(() =>
      items?.value?.length ? items.value.length : 0
    );
    watch(query, async (val, _, onInvalidate) => {
      onInvalidate(() => (items.value = null));
      const q = {
        area: val.area,
        q__date: val.date,
        size: 10000,
        page: 1,
      };
      if (q.q__date === null) {
        return;
      }

      const d = await ctx.root.$callapi("getFlightList", q);
      items.value = d.data.items;
    });

    const product_id = ctx.root.$route.params.id;
    const is_favorite = ref();
    onMounted(async () => {
      const res = await ctx.root.$callapi("user/queryCollects", {
        model: "product",
        objids: product_id,
      });
      is_favorite.value = path(["data", product_id])(res);
    });
    // 收藏相关
    const addFavorite = async (e) => {
      const _callapi = (action) =>
        ctx.root.$callapi("user/doCollect", {
          model: "product",
          objid: product_id,
          action,
        });

      const favorite = new Map([
        [true, () => _callapi("cancel")],
        [false, () => _callapi()],
      ]);

      await favorite.get(e)();
      is_favorite.value = !e;
    };

    // 购物车
    const user = computed(() => ctx.root.$store.getters.user);
    const addCart = async () => {
      if (!user.value.id) {
        ctx.root.$toast(ctx.root.$t('未登录状态下不能加入购物车'), "error")
        return
      }
      const cart_info = computed(() => {
        return ctx.root.$store.state.cart.cart;
      });
      try {
        const cart_info = computed(() => {
          return ctx.root.$store.state.cart.cart;
        });
        const in_cart = find(
          ({ product }) => product.id === Number(ctx.root.$route.params.id)
        )(cart_info.value);
        const res = in_cart
          ? ctx.root.$toast(ctx.root.$t("商品已存在购物车"))
          : (async () => {
            const aa = await ctx.root.$callapi("trade/editWithCart", {
              pid: product_id,
              quantity: form.count,
            });
            const r = await ctx.root.$callapi("trade/getMyCartList");
            ctx.root.$store.commit("SAVE_CART", r.data);
            ctx.root.$toast(ctx.root.$t("已添加购物车"), "success");
          })();
      } catch (e) {
        ctx.root.$toast(ctx.root.$t(e), "error");
      }
    };

    // 购买
    const buy = async () => {
      if (user.value.id) {
        let res = await ctx.root.$callapi('trade/editWithCart', {
          pid: product_id,
          quantity: form.count
        })
        if (res.code == 0 && res.data) {
          let cids = res.data.id
          let sids = res.data.product.supplier_info.sid
          ctx.root.$router.push({
            path: "/product/dealOrder",
            query: {
              cids,
              sids,
              curWh:props.curWh 
            }
          })
        }
      } else {
        ctx.root.$toast("未登录状态下不能购买", "error")
      }
    };

    const chooseFlight = async (e) => {
      await ctx.root.$callapi("setNationalSetting", { flight: e });
    };


    return {
      ...toRefs(areas),
      form,
      query,
      items,
      addFavorite,
      is_favorite,
      changeDate,
      changeId,
      chooseFlight,
      itemsLength,
      addCart,
      buy
    };
  },
};
</script>

<style scoped lang="scss">@import "@/style/stl.scss";
.flightboard {
  display: -ms-grid;
  display: grid;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  grid-gap: 0.5rem;
  gap: 0.5rem;
}
.favorite {
  --tw-text-opacity: 1;
  color: rgba(245, 158, 11, var(--tw-text-opacity));
}</style>
